import React from "react";
import ItrForm from "../components/custom/ItrForm";
import { Stack } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

const FormScreen = () => {
  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>File Your Income Tax Return (ITR) - 360fintax</title>
        <meta
          name="description"
          content="Easily file your Income Tax Return with 360fintax. Our streamlined process ensures accurate and timely filing, assisting you at every step."
        />
        <link
          rel="canonical"
          href="https://tax-services-web.vercel.app/itr-form"
        />
      </Helmet>

      {/* Form */}
      <Stack
        py={{ base: "10", md: "10" }}
        className="fade-section"
        data-scroll
        data-scroll-class="fade-in"
      >
        <ItrForm />
      </Stack>
    </>
  );
};

export default FormScreen;
